(() => {
  if (window.__ssTrustBarStickyInitialized) return;
  window.__ssTrustBarStickyInitialized = true;

  const sync = () => {
    const bar = document.querySelector('.ss-global-trust-bar');
    if (!bar) return;

    const section = bar.closest('.shopify-section') || bar.closest('.section-wrapper') || bar.parentElement;
    if (section instanceof HTMLElement) section.classList.add('ss-global-trust-bar-section');

    const height = Math.max(1, Math.round(bar.getBoundingClientRect().height));
    document.documentElement.style.setProperty('--ss-trust-bar-height', `${height}px`);
  };

  const boot = () => {
    sync();
    const bar = document.querySelector('.ss-global-trust-bar');
    if (bar && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(sync);
      observer.observe(bar);
    }
    window.addEventListener('resize', sync, { passive: true });
    document.addEventListener('shopify:section:load', sync);
    window.setTimeout(sync, 120);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
